<template>
  <TsCardProductWithCollectionDelivery
    v-if="!isLoading && productData"
    :product="props.productData"
    :class="props.appendClass"
    :subscribedDate="formattedDate"
  >
    <template #productCardButtons>
      <div class="w-full">
        <TsButton
          icon="material-symbols:unsubscribe-outline"
          :label="useTranslation('unsubscribe','Uitschrijven')"
          :is-loading="isStockUnsubscribeCTAloading"
          @click="unsubscribeProduct"
          append-class="whitespace-nowrap px-2.5 gap-1.5"
          size="sm"
          block
          :data-testid="`account-stock-notification-unsubscribe-cta-${productData.code}`"
          :outlined="props.buttonOutlined"
        />
      </div>
    </template>
  </TsCardProductWithCollectionDelivery>
  <div v-else-if="isLoading">
    <TsProductCardTransition class="mt-2 mx-2"></TsProductCardTransition>
  </div>
  <div v-else>
    <TsTypography variant="h6" appendClass="text-natural-grey text-center mb-3">
      {{useTranslation('productNotFoundErrorOccurred','Product niet gevonden of er is een fout opgetreden.')}}
    </TsTypography>
  </div>
</template>

<script setup lang="ts">
import type { Product } from '~/types/ecom/product/product.type';
import {toastErrors} from "~/services-optimized/toastService";

type Props = {
  productData:Product;
  createdAt: string;
  buttonOutlined?: boolean;
  appendClass?: string;
};

const { $customClientErrorHandler } = useNuxtApp();

const props = defineProps<Props>();
const emit = defineEmits(["unsubscribed"]);
const productStore = useProductStore();
const isLoading = ref(true);
const isStockUnsubscribeCTAloading = ref(false);
const formattedDate = computed(() => {
  const date = new Date(props.createdAt);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
});

const TsCardProductWithCollectionDelivery = defineAsyncComponent(
    () => import('~/components/organisms/TsCardProductWithCollectionDelivery.vue')
);

onMounted(async () => {
    isLoading.value = false;
  
});

const unsubscribeProduct = async () => {
  isStockUnsubscribeCTAloading.value = true;
  try{
  const success = await productStore.unSubscribeProduct(props.productData.code);
  if (success) emit("unsubscribed", props.productData.code);
  }
  catch(e){
    let errorMeta = {productCode: props.productData.code, unsubscribeProductError: true}

    $customClientErrorHandler(
        e,
        'medium',
        'Unsubscribe Product Error - trying to unsubscribe product using unsubscribeProduct()',
        errorMeta
    );
    await toastErrors([useTranslation('Toast-failedToUnsubscribe', 'Afmelden is mislukt. Probeer het opnieuw')], "top-right");
  }
  finally{
    isStockUnsubscribeCTAloading.value = false;
  }
};
</script>
